// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WsTW","index":"styles_index__3F1i_"};